'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import clsx from 'clsx';

const NavLink = ({
  href,
  children,
  exact = false,
  className = '',
  activeClassName = 'text-gradientStart',
  ...props
}) => {
  const pathname = usePathname();
  

  const isActive = exact
    ? pathname === href
    : pathname === href || pathname.startsWith(`${href}/`);

  return (
    <Link
      href={href}
      className={clsx(className, isActive && activeClassName)}
      {...props}
    >
      {children}
    </Link>
  );
};

export default NavLink;
